import { LINK_ACTIONS } from 'modules/linkExpirationManagement/constants';
import { Controller, useFormContext } from 'react-hook-form';
import styled from 'styled-components';
import { FormField } from 'ui/formField';
import { InputText } from 'ui/inputs';
import { Body2, spacing } from 'ui/theme';
import { Cell } from './Table.styled';

export const LOCATION_CELL_TEXT = {
  terminateMessage: 'Users will be redirected to a standard 404 page',
  redirectMessage: 'Add a custom location',
};

const { terminateMessage, redirectMessage } = LOCATION_CELL_TEXT;

const StyledFormField = styled(FormField)`
  width: 100%;
  max-width: ${spacing.x24};
`;

const TerminateMessage = styled(Body2)`
  align-self: center;
  padding-top: ${spacing.fiveEights};
  padding-bottom: ${spacing.fiveEights};
  margin-bottom: 0;
`;

export const LocationCell = ({ linkAction, name }: { linkAction: string; name: string }) => {
  const { watch } = useFormContext();
  const redirectLocation = watch(name);

  return (
    <Cell>
      <Controller
        name={name}
        render={({ field: { onChange }, fieldState: { error } }) => {
          return linkAction === LINK_ACTIONS.terminate ? (
            <TerminateMessage>{terminateMessage}</TerminateMessage>
          ) : (
            <StyledFormField hasError={!!error} errorText={error?.message}>
              <InputText
                data-test="link-location-input"
                name={name}
                onChange={onChange}
                placeholder={redirectMessage}
                value={redirectLocation}
              />
            </StyledFormField>
          );
        }}
      />
    </Cell>
  );
};
